<template>
  <div class="mb-3">
    <label :for="id">
      {{ label }} <span v-if="required" class="text-danger">*</span>
    </label>
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, meta, errorMessage }"
    >
      <select
        v-bind="field"
        :id="id"
        class="form-control"
        :class="{
          'is-invalid': meta.touched && !meta.valid,
          'is-valid': meta.touched && meta.valid && !errorMessage,
        }"
      >
        <option value="" disabled>Seleccione una opción</option>
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.key }}
        </option>
      </select>
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array,
    default: () => [],
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});
</script>
